import { Color } from 'root-constants'
import styled from 'styled-components'
import checkOff from '../assets/images/check-off-plus.svg'
import checkOn from '../assets/images/check-on-black.svg'

export const StyledQuestionButton = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    height: 64px;
    font-size: 15px;
    line-height: 16px;
    padding: 11px 16px;
    color: ${Color.BLACK_SECONDARY};
    background-color: #f5f5f5;
    border-radius: 16px;
    transition: background-image 0.2s ease-out, background-color 0.2s ease-out;
    font-family: 'Inter', sans-serif;

    input:checked + & {
      background-color: ${Color.WHITE};
      outline: 2px solid ${Color.BLACK_SECONDARY};
    }

      background-image: url("${checkOff}");
      background-repeat: no-repeat;
      background-position: right 14px center;
      padding-right: 46px;

      input:checked + & {
        background-image: url("${checkOn}");
      }

    .option-image {
      width: 56px;
      height: 56px;
      margin-left: -16px;
      margin-right: 8px;
    }
  `,
}
